import { Button, Card, CardContent, Grid, Typography } from '@material-ui/core';

const FinishTab = ({ mainBookFormStore, userStore }) => {
    const getLinksText = () => {
      if (mainBookFormStore.showLinks === false) {
        return 'Não disponível';
      }

      if (
        mainBookFormStore.errors.linksAmazonFields.physical_url === false &&
        mainBookFormStore.errors.linksAmazonFields.isbn === false &&
        mainBookFormStore.errors.linksAmazonFields.digital_url === false &&
        mainBookFormStore.errors.linksAmazonFields.asin === false
      ) {
        return 'Físico e digital'
      }

      if (
        (mainBookFormStore.errors.linksAmazonFields.physical_url === false &&
        mainBookFormStore.errors.linksAmazonFields.isbn === false) &&
        (
          mainBookFormStore.errors.linksAmazonFields.digital_url ||
          mainBookFormStore.errors.linksAmazonFields.asin
        )
      ) {
        return 'Apenas físico';
      }

      if (
        (mainBookFormStore.errors.linksAmazonFields.digital_url === false &&
        mainBookFormStore.errors.linksAmazonFields.asin === false) &&
        (
          mainBookFormStore.errors.linksAmazonFields.physical_url ||
          mainBookFormStore.errors.linksAmazonFields.isbn
        )
      ) {
        return 'Apenas digital';
      }

      return 'Incompleto';
    }
    return (
      <Card>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h2">1. Informacões Gerais</Typography>
              <br />
              <Typography variant="h3">
                {mainBookFormStore.tabsErrors[0] ? 'Incompleto' : 'Preenchido'}
              </Typography>
              <br />
              <br />
              <hr />
              <br />
              <br />
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant='h2'>2. Reviews</Typography>
              <br />
              <Typography variant="h3">
                {mainBookFormStore.showReviews === false ? 'Sem review' : mainBookFormStore.tabsErrors[1] ? 'Incompleto' : 'Preenchido'}
              </Typography>
              <br />
              <br />
              <hr />
              <br />
              <br />
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant='h2'>3. Seller - Amazon</Typography>
              <br />
              <Typography variant='h3'>
                {getLinksText()}
              </Typography>
              <br />
              <br />
              <hr />
              <br />
              <br />
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={12} display="flex" justifyContent="center" justifyItems="center">
              <Button variant="contained" size="large" disabled={mainBookFormStore.tabsErrors[3]}
                      onClick={e => mainBookFormStore.saveBook(userStore)}>Salvar livro pai</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
};

export default FinishTab;
